import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { environment } from '@src/environments/environment';
import { AppSettingsService } from '@app/services/global-services/app/app-settings.service';
import { RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '@app/services/util-services/root-services/toast-service';
import { Subscription } from 'rxjs';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';

@Component({
  selector: 'app-b2b-desktop-footer',
  templateUrl: './b2b-desktop-footer.component.html',
  styleUrls: ['./b2b-desktop-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, NgOptimizedImage],
})
export class B2bDesktopFooterComponent implements OnInit, OnDestroy {
  extranetUrl: string = environment.extranetUrl;
  isBrowser: boolean;

  subscribeNewsletterSubscription$: Subscription;
  imgHost: string = environment.imgHost;

  protected readonly environment = environment;

  constructor(
    private appSettingsService: AppSettingsService,
    @Inject(PLATFORM_ID) private platformId: string,
    private toastService: ToastService,
    private httpClientService: HttpClientService,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    }
  }

  openChatBox() {
    this.appSettingsService.setupTawk();
  }

  submit(emailId: string) {
    this.subscribeToNewsLetter(emailId);
  }

  subscribeToNewsLetter(emailId: string) {
    if (emailId === undefined || emailId === null || emailId?.trim() === '') {
      // TODO
      this.toastService.error('Please fill your Email ID');
      // this.LoggerService.log('Filter list page search result ');
      return;
    }

    if (!emailId?.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})$/)) {
      this.toastService.error('Please enter valid email id');
      return;
    }

    this.subscribeNewsletterSubscription$ = this.httpClientService
      .post(
        'user-service/subscribe-to-news-letter',
        {
          emailId,
        },
        {},
      )
      .pipe()
      .subscribe({
        next: (result: { success: boolean }) => {
          this.toastService.success('Thank you for Subscribing');
        },
        error: (errorResponse: HttpErrorResponse) => {
          this.toastService.showApiError(errorResponse);
        },
      });
  }

  ngOnDestroy(): void {
    if (this.subscribeNewsletterSubscription$) {
      this.subscribeNewsletterSubscription$?.unsubscribe();
    }
  }
}
